<template>
  <div
    class="Fuell-Overlay"
    @click.self="closeModal"
  >
    <div class="Fuell-Modal">
      <div class="Fuell-Modal--window Fuell-Modal--window--centered">
        <button
          class="Fuell-Modal--close-button"
          @click="closeModal"
        >
          <img
            :src="require('@/assets/img/icons/close.svg')"
            alt="close"
          />
        </button>
        <h3
          class="Fuell-Modal--title"
          v-t="{ path: 'accounting_close_accounting_periods' }"
        ></h3>
        <template v-if="!isClosingPeriod">

          <div class="Fuell-Modal--content">
            <p class="Fuell-Text Fuell-Text--centered">
              {{ $t('accounting_periods_closure_transaction_closure_warning') }}
              <br>
              {{ $t('accounting_periods_closure_transaction_closure_undo_warning') }}
            </p>

            <spinner v-if="isFetchingTransactions" />
            <div class="multiselect--modal">
              <multiselect
                :options="accountingPeriods"
                v-model="selectedAccountingPeriod"
                :showLabels="false"
                :hideSelected="false"
                label="name"
                :placeholder="
                $t('accounting_select_accounting_period_placeholder')
              "
                @select="setAccountingDates"
              >
                <div
                  class="caret"
                  slot="caret"
                  slot-scope="{ toggle }"
                  @mousedown.prevent.stop="toggle"
                >
                  <i
                    class="Ctrl Ctrl--16"
                    aria-hidden="true"
                  >
                    <svg
                      focusable="false"
                      aria-hidden="true"
                      aria-label="Edit"
                    >
                      <use xlink:href="#dropdown-icon"></use>
                    </svg>
                  </i>
                </div>

                <template
                  slot="option"
                  slot-scope="props"
                >
                  <span :class="{ 'disabled--text': props.option.isClosed }">
                    {{`${props.option.name} ${props.option.isClosed ? '(ya cerrado)' : ''}`}}
                  </span>
                </template>
              </multiselect>

            </div>
            <div class="Fuell-Modal--footer">
              <button
                class="Fuell-Button blue"
                :disabled="!hasAnyDateForTransactions || isClosingPeriod"
                :class="{ grey: !hasAnyDateForTransactions || isClosingPeriod }"
                @click="showConfirmModal"
              >
                <span
                  class="Fuell-Button--label"
                  v-t="{ path: 'accounting_periods_action_close_periods' }"
                ></span>
              </button>
            </div>

          </div>
        </template>
        <div
          class="Fuell-Modal--content"
          v-else
        >
          <p v-t="{ path: 'accounting_closure_in_progress' }"></p>
          <spinner />
        </div>

      </div>
    </div>
    <confirm-modal
      :open.sync="showConfirmModalFlag"
      @accept="closeAccountingPeriod"
      @dismiss="closeModal"
      v-if="showConfirmModalFlag"
      :message="''"
      :title="'transactions_action_close_accounting_periods_title'"
      :acceptText="'transactions_action_close_accounting_periods_title'"
    >
      <template v-slot:additional>
        <p class="Fuell-Text">
          {{ $t('accounting_period_closure_warning') }}
          <i18n
            path="accounting_period_closure_transactions_affected"
            v-if="incompletedTransactions.length > 0"
          >
            <template v-slot:amount>
              <span class="text-primary">{{
                incompletedTransactions.length
              }}</span>
            </template>
            <template v-slot:action>
              <span
                class="text-primary"
                @click="setIncompleteTransactionFilters"
              >{{ $t('accounting_period_action_click') }}</span>
            </template>
          </i18n>
        </p>
      </template>
    </confirm-modal>
  </div>
</template>

<script>
import transactionsApi from '@/modules/transactions/_api'
import accountingApi from '@/modules/accounting/_api'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import Multiselect from 'vue-multiselect'
import Spinner from '@/components/Commons/Spinner'
import { segmentTrack } from '@/analytics/segment'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'AccountingPeriodsClosureModal',
  mixins: [_modalHandlerMixin],
  components: { Multiselect, ConfirmModal, Spinner },
  computed: {
    accountingPeriods () {
      return (
        this.$store.getters['AccountingStore/accountingPeriods'].map(el => {
          if (el.isClosed) {
            return { ...el, $isDisabled: true }
          } else {
            return {
              ...el
            }
          }
        }) || []
      )
    },
    hasAnyDateForTransactions () {
      return !!(
        (this.startDate && this.endDate) ||
        this.selectedAccountingPeriod
      )
    }
  },
  data () {
    return {
      startDate: null,
      endDate: null,
      showConfirmModalFlag: false,
      incompletedTransactions: 0,
      selectedAccountingPeriod: null,
      isFetchingTransactions: false,
      isClosingPeriod: false
    }
  },
  methods: {
    setField (fieldName, value) {
      if (!fieldName || !value) return

      this[fieldName] = new Date(value)

      this.selectedAccountingPeriod = null
    },
    setAccountingDates (event) {
      this.startDate = null
      this.endDate = null
    },
    async showConfirmModal () {
      await this.fetchTransactions()
      this.showConfirmModalFlag = true
    },
    async fetchAccountingPeriods () {
      await this.$store.dispatch(
        'AccountingStore/fetchAccountingPeriods',
        false
      )
    },
    async fetchTransactions () {
      if (this.hasAnyDateForTransactions) {
        const filters = {
          'date[after]':
            this.selectedAccountingPeriod &&
              this.selectedAccountingPeriod.startDate
              ? this.selectedAccountingPeriod.startDate
              : this.$moment.utc(this.startDate).format(),
          'date[before]':
            this.selectedAccountingPeriod &&
              this.selectedAccountingPeriod.endDate
              ? this.selectedAccountingPeriod.endDate
              : this.$moment.utc(this.endDate)
                .add(23, 'hours')
                .add(59, 'minutes')
                .add(59, 'seconds')
                .format(),
          'status.code': ['OK'],
          /* 'type.code': this.$route.name.includes('transactions') ? ['NORMAL'] : ['EXPENSE'], */
          isCompleted: false
        }
        this.isFetchingTransactions = true
        const response = await transactionsApi.getTransactions(
          1,
          false,
          filters
        )
        this.incompletedTransactions = response.data
        this.isFetchingTransactions = false
      }
    },
    async closeAccountingPeriod () {
      let accountingPeriodClosureInformation = {}
      if (this.selectedAccountingPeriod) {
        accountingPeriodClosureInformation = {
          name: this.selectedAccountingPeriod.name,
          startDate: this.selectedAccountingPeriod.startDate,
          endDate: this.selectedAccountingPeriod.endDate,
          sign: 'fuell',
          status: 'lock'
        }
      } else {
        accountingPeriodClosureInformation = {
          startDate: this.$moment.utc(this.startDate)
            .subtract(1, 'hour')
            .format(),
          endDate: this.$moment.utc(this.endDate)
            .add(23, 'hours')
            .add(59, 'minutes')
            .add(59, 'seconds')
            .format(),
          sign: 'fuell',
          status: 'lock'
        }
      }
      try {
        this.isClosingPeriod = true
        await accountingApi.postAccountingPeriod(
          accountingPeriodClosureInformation
        )
        this.isClosingPeriod = false
        segmentTrack('Close accounting period', {
          options_number: this.accountingPeriods.filter(el => !el.isClosed).length,
          period: accountingPeriodClosureInformation.name

        })

        this.$store.dispatch('TransactionsStore/fetchTransactions')
        this.$store.dispatch(
          'SnackBars/addSuccess',
          this.$t('accounting_periods_closure_success')
        )
        this.closeModal()
      } catch (error) {
        this.$store.dispatch(
          'SnackBars/addErrorHandler',
          { error: error, errorMessage: 'accounting_periods_closure_error' },
          { root: true }
        )
      } finally {
        this.isClosingPeriod = false
      }
    },
    async setIncompleteTransactionFilters () {
      // TODO: When accountingPeriod filter is fixed we should check in here for transactions not closed on the given period
      const filters = {
        'date[after]':
          this.selectedAccountingPeriod &&
            this.selectedAccountingPeriod.startDate
            ? this.selectedAccountingPeriod.startDate
            : this.$moment.utc(this.startDate).format(),
        'date[before]':
          this.selectedAccountingPeriod && this.selectedAccountingPeriod.endDate
            ? this.selectedAccountingPeriod.endDate
            : this.$moment.utc(this.endDate)
              .add(23, 'hours')
              .add(59, 'minutes')
              .add(59, 'seconds')
              .format(),
        'status.code': ['OK'],
        isCompleted: false
      }
      this.$store.dispatch('TransactionsStore/setTransactionsFilters', {
        filters: filters
      })
      this.closeModal()
    }
  },
  async created () {
    await this.fetchAccountingPeriods()
  }
}
</script>

<style lang="scss" scoped>
.Fuell-Modal--window {
  @media screen and (max-width: 576px) {
    height: 100vh;
  }
}
.Fuell-Modal--content {
  @media screen and (max-width: 576px) {
    justify-content: space-between;
    overflow: hidden;
  }
}

.Fuell-Button {
  @media screen and (max-width: 576px) {
    margin-bottom: 200px;
  }
}
.multiselect--modal {
  width: 100%;
}
.multiselect--modal >>> .caret {
  width: 5%;
}
</style>
